export const CabinBagsEnum = {
  SMALL_BAG: 'BO_SB',
  CABIN_BAG: 'BO_PB',
  HAND_BAG: 'BO_HB',
  INCLUDED: 'BO_INC',
};
